/** Shared pieces of the two Suspense data sources (`TimelineDataStreamer`, `ActivityLoader`). */

/** A promise and the hook to settle it from outside. */
export interface Deferred {
  promise: Promise<void>;
  resolve: () => void;
}

export function deferred(): Deferred {
  let resolve!: () => void;
  const promise = new Promise<void>((done) => {
    resolve = done;
  });
  return { promise, resolve };
}

/**
 * What a disposed source hands a component that would suspend on it: React
 * drops the promise when the subtree is replaced, and nothing else may ever
 * wake that render.
 */
export const NEVER: Promise<never> = new Promise<never>(() => {});

/** For `useSyncExternalStore` when there is no source to subscribe to yet. */
export const NO_SUBSCRIPTION = () => () => {};
